const conditionForm = {
  bindings: {
    conditions: '<',
    selection: '<',
    onFormSubmit: '&',
    hasEdit: '<',
    isLocked: '<',
  },
  templateUrl:
    '/modules/pis-tool/conditions/condition-form/condition-form.html',
  controller: 'ConditionFormController',
};

angular
  .module('pis-tool.module')
  .component('conditionForm', conditionForm);
